import {dataRegister} from "./dataRegister";
import {EventEmitter} from "./eventRegister"
import Pusher from 'pusher-js';

const pusher = new Pusher('5688dc5fc1fa3c9399ee', {
    cluster: 'ap2',
    forceTLS: true
});

const channel = pusher.subscribe('saleschannel-video');
const id = window.crypto.getRandomValues(new Uint32Array(1))[0].toString(16);
channel.bind(id, function(data) {
    try {
        if(data.percent){
            videoRegister.setPercentage(data.percent);
        }
    }catch (e) {}
});

class videoRegister {

    static video = null;
    static called = false;
    static block = false;
    static error = false;
    static progress = 0;

    static setVideo(video){
        videoRegister.video = video;
        try {
            sessionStorage.setItem('video', JSON.stringify(video));
        }catch (e) {}
    }

    static setPercentage(percentage){
        if(percentage > videoRegister.progress || percentage === 0){
            videoRegister.progress = percentage;
            EventEmitter.emit('video-progress', videoRegister.progress);
        }
    }

    static setError(value){
        videoRegister.error = value;
        try {
            if(value){
                EventEmitter.emit('video-error', true);
                sessionStorage.setItem('video-error', value);
            }else{
                EventEmitter.emit('video-error', false);
                sessionStorage.removeItem('video-error');
            }
        }catch (e) {}
    }

    static getError(){
        try {
            if(videoRegister.error){
                return true;
            }else if(sessionStorage.getItem('video-error')){
                return true;
            }else{
                return false;
            }
        }catch (e) {
            return false;
        }
    }

    static getProgress(){
        return videoRegister.progress;
    }

    static get(){
        try {
            if(!videoRegister.called){
                if(videoRegister.video){
                    return videoRegister.video;
                }
                else if(sessionStorage.getItem('video')){
                    return JSON.parse(sessionStorage.getItem('video'));
                }else{
                    return null;
                }
            }else{
                return null;
            }
        }catch (e) {
            return null;
        }
    }

    static create(data){
        if(!videoRegister.called && !videoRegister.get() && data){
            videoRegister.setPercentage(0);
            videoRegister.called = true;
            videoRegister.setError(false);

            //SET ID
            data.session_id = id;

            dataRegister.createVideo(data).then((response) => {
                if(!videoRegister.block){
                    videoRegister.setVideo(response);
                    EventEmitter.emit('video', response);
                }
                videoRegister.setError(false);
                videoRegister.block = false;
                videoRegister.called = false;
            }, (error) => {
                videoRegister.setPercentage(0);
                videoRegister.setError(true);
                videoRegister.called = false;
                videoRegister.block = false;
            }).catch((error) => {
                videoRegister.setPercentage(0);
                videoRegister.setError(true);
                videoRegister.called = false;
                videoRegister.block = false;
            });
        }
    }

    static remove(){
        videoRegister.setPercentage(0);
        videoRegister.video = null;
        videoRegister.error = null;
        videoRegister.setError(false);
        if(videoRegister.called){
            videoRegister.block = true;
            videoRegister.called = false;
        }
        try {
            sessionStorage.removeItem('video');
        }catch (e) {}
    }


}

export {videoRegister}


// WEBPACK FOOTER //
// ./src/services/videoRegister.js